import { Expose, Transform } from 'class-transformer';
import { convertToDateString } from '../../../util/misc-utils';

export class ViewCustomersExportRow {
  @Expose()
  CUST_ID: string;

  @Expose()
  CUST_NAME: string;

  @Expose()
  CUST_TYPE: string;

  @Expose()
  CUST_DISCOUNT_RATE: number;

  @Expose()
  CUST_NOTES: string;

  @Expose()
  @Transform(({ value }) => convertToDateString(value))
  CUST_CREATED_AT: string;

  @Expose()
  ADDRESS_ID?: string;

  @Expose()
  ADDRESS_TYPE?: string;

  @Expose()
  ADDRESS_CODE?: string;

  @Expose()
  ADDRESS_NAME?: string;

  @Expose()
  ADDRESS_STREET1?: string;

  @Expose()
  ADDRESS_STREET2?: string;

  @Expose()
  ADDRESS_CITY?: string;

  @Expose()
  ADDRESS_STATE?: string;

  @Expose()
  ADDRESS_ZIP?: string;

  @Expose()
  ADDRESS_ROUTE_NAME?: string;

  @Expose()
  @Transform(({ value }) => convertToDateString(value))
  ADDRESS_CREATED_AT?: string;

  @Expose()
  CONTACT_ID?: string;

  @Expose()
  CONTACT_FIRST_NAME?: string;

  @Expose()
  CONTACT_LAST_NAME?: string;

  @Expose()
  CONTACT_EMAIL?: string;

  @Expose()
  CONTACT_MOBILE_PHONE?: string;

  @Expose()
  CONTACT_OFFICE_PHONE?: string;

  @Expose()
  CONTACT_FAX?: string;

  @Expose()
  @Transform(({ value }) => convertToDateString(value))
  CONTACT_CREATED_AT?: string;
}
